module.exports = __webpack_public_path__ + "static/media/Co2.91b593e4.svg";